import React from 'react';
import {ChoiceQuestionDto, EssayQuestionDto, FillQuestionDto, UserRole} from '../../scaffold';
import MarkdownRender from '../Shared/MarkdownRender';
import Flex from '../Shared/Flex';
import Text from 'antd/lib/typography/Text';
import {IQuestionDisplayProps} from './QuestionDisplay';
import useAuth from '../../utils/AuthContext';

export default function EssayQuestionDisplay(props: IQuestionDisplayProps<EssayQuestionDto>) {
  const {question} = props;
  const auth = useAuth();
  const isStudent = auth.currentUser?.role === UserRole.学生;
  return (
    <div>
      <MarkdownRender className={'smallMarkdown'} md={'**[' + (isStudent ? '论述关' : '论述题') + ']** ' + question.topic || ''} />
      {!props.hideRightAnswer && (
        <div className={'m-t-5'}>
          <Text strong>参考答案: </Text>
          <MarkdownRender className={'smallMarkdown'} md={question.rightAnswer || ''} />
        </div>
      )}
    </div>
  );
}
